import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IAppUserFormValues } from './AppUserForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { AppRolesSelector } from '~/components/organisms/fields/AppRolesSelector';
import { OrganizationUserSelector } from '~/components/organisms/fields/OrganizationUserSelector';
import { useApi } from '~/lib/api';

export type IAppUserFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IAppUserFormValues>;
  mode: IFormMode;
  organizationId: string;
};

export const AppUserFormMainSection: React.FC<IAppUserFormMainSectionProps> = (
  props,
) => {
  const { sx, form, organizationId, mode } = props;
  const { t } = useTranslation();
  const api = useApi();
  const currentUserId = api.getCurrentUserId();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('common.appUser')}
        required
        readOnly={mode === 'edition'}
      >
        <FormField
          name="userId"
          control={form.control}
          // TODO: Use AppUserSelector
          as={OrganizationUserSelector}
          forwardError
          organizationId={organizationId}
          filter={
            currentUserId && mode === 'creation'
              ? { excludeIds: [currentUserId] }
              : undefined
          }
        />
      </Labeled>

      <Labeled label={t('common.roles')} required>
        <FormField
          name="roles"
          control={form.control}
          as={AppRolesSelector}
          forwardError
          emptyValue={[]}
        />
      </Labeled>
    </FormSection>
  );
};
